<template>
  <div
    :class="{
      'custom-table': true,
    }"
  >
    <div
      :class="{
        'overflow-x-auto': mobileResponsive == 'overflowScroll',
        'hidden md:block': mobileResponsive == 'stack',
      }"
    >
      <table
        :class="{
          'w-full table-auto md:table-fixed': true,
          'border border-www-color-neutral-light': border == 'outer' || border == 'all',
        }"
      >
        <tbody>
          <tr
            v-for="row in rows"
            :key="row._key"
            :class="{
              group: true,
            }"
          >
            <td
              v-for="cell in row.cells"
              :key="cell._key"
              :class="{
                'border border-www-color-neutral-light': border == 'all',
                'group-odd:bg-www-color-neutral-off-white group-even:bg-www-color-white':
                  stripedRows,
                'py-3 text-center': true,
              }"
            >
              <PortableText
                v-if="cell.tableCellPortableText"
                :portable-data="cell.tableCellPortableText"
                :class="{
                  'text-www-color-neutral-dark': stripedRows,
                }"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      :class="{
        'md:hidden': mobileResponsive === 'stack',
        hidden: mobileResponsive === 'overflowScroll',
      }"
    >
      <div
        v-for="row in rows"
        :key="row._key"
        :class="{
          'bg-white border border-www-color-neutral-light p-4': true,
          'odd:bg-www-color-neutral-off-white even:bg-www-color-white': stripedRows,
        }"
      >
        <div
          v-for="(cell, index) in row.cells"
          :key="cell._key"
          :class="{
            'mb-3 last:mb-0': true,
            'border-t border-www-color-neutral-light pt-3': index !== 0,
          }"
        >
          <PortableText
            v-if="cell.tableCellPortableText"
            :portable-data="cell.tableCellPortableText"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import type { CustomTable } from '~/sanity/types';
type extendedCustomTable = CustomTable & {
  mobileResponsive?: 'overflowScroll' | 'stack';
  border?: 'none' | 'outer' | 'all';
  stripedRows?: boolean;
};
defineProps<extendedCustomTable>();
</script>

<style scoped></style>
